export default "__VITE_ASSET__OqGYuAgq__"